import React from 'react' 
import './record.css' 
const record = () => (
    // Div Container
<div className='record-container'> 
{/* Main heading container */}
<h1 className='record-heading1'>Academics</h1> 
{/* p1, LHS record component */}

<h2 className='record-heading2'>
LHS
</h2>

<p1 class='recordp1'>
-4.04 Cumalative GPA <br/>
-Honor Roll all 4 years  <br/> 
-Finished with 30 Dual College Credits <br/> 
</p1>
 





</div>
);
export default record 